<header class="header-with-menu py-5 px-5 bg-white">
  <div class="header-with-menu__container flex justify-between items-center mx-auto" [ngClass]="{'rowCheckout': isCheckout, 'isUpsellDownsell': showOnUpsell}">
    <img class="headerWithMenu__headerLogo" src="{{ icon }}" alt="Terra Mare Logo" loading="eager" fetchpriority="high" decoding="sync" width="200" height="auto"> 

    <ng-container *ngIf="!isCheckout">
      <div class="font-sans text-sm desktop:text-lg" [innerHTML]="phone"></div>
    </ng-container>

    <ng-container *ngIf="isCheckout && headerText">
      <div class="header-text font-sans text-right text-sm" [innerHTML]="headerText"></div>
    </ng-container>

  </div>
</header>
